import { render, staticRenderFns } from "./Tier2NavDesktop.vue?vue&type=template&id=0a1a5b24&"
import script from "./Tier2NavDesktop.vue?vue&type=script&lang=js&"
export * from "./Tier2NavDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports